import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import {
  getCuratorPlatformBaseUrl as resolveCuratorPlatformBaseUrl,
  getCuratorPlatformLoginUrl,
} from '../config/platformUrls.js';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getCuratorPlatformBaseUrl() {
  return resolveCuratorPlatformBaseUrl();
}

export { getCuratorPlatformLoginUrl };

export function redirectToCuratorLogin() {
  window.location.href = getCuratorPlatformLoginUrl();
}

export function redirectToCuratorPlatform() {
  redirectToCuratorLogin();
}
